import React, { useEffect, useRef, useState } from 'react'

import { 
  GashaContainer,
  Container,
  AnimatedImage
 } from './styles'
import { useCanjearGachapon } from "../../../Hooks/Player";

import { Maquina } from './Components/Maquina'
import { Capsulas } from './Components/Capsulas'

import useSound from 'use-sound';
import GACHASONG from '../../../Assets/gachasong.mp3';

export const GashaponV2 = ({gacha_id, coin_id, pokemons, imagenesCache}) => {
  const [pokemonSelected, setPokemonSelected] = useState([]);
  const [keyCache, setKeyCache] = useState(null);
  const { mutateAsync } = useCanjearGachapon();

  const [songFX, {stop}] = useSound(GACHASONG, {
    volume: 0.05,
    loop: true,
    // `interrupt` ensures that if the sound starts again before it's
    // ended, it will truncate it. Otherwise, the sound can overlap.
    interrupt: true,
  });

  function useOnMount(callback) {
    songFX();
    const hasRun = useRef(false);

    useEffect(() => {
      if (!hasRun.current) {
        hasRun.current = true;
        callback();
      }
    }, []);
  }
  useOnMount(() => {
    if (gacha_id && coin_id) {
      mutateAsync({
        idGacha: gacha_id,
        idFicha: coin_id
      }).then(resultaGacha => {
        setPokemonSelected(resultaGacha?.datos.pokemonSelected);
        setKeyCache(resultaGacha?.datos.keyCache)
      }).catch(() => {
        setPokemonSelected([]);
      });
    }
  });

  return (
    <>
      <ImagePanning src={imagenesCache[8]}/>
      <GashaContainer src={imagenesCache[0]}>
          <Maquina coin_id={coin_id} gacha_id={gacha_id} pokemonSelected={pokemonSelected} imagenesCache={imagenesCache} stopSong={stop} keyCache={keyCache}>
            <Capsulas pokemon={pokemons} imagenesCache={imagenesCache} />
          </Maquina>
      </GashaContainer>
    </>
  )
}

const ImagePanning = ({ src }) => {
  const [visible, setVisible] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <Container>
      <AnimatedImage
        src={src}
        onLoad={() => setLoaded(true)}
        initial={{ scale: 2, y: 0, opacity: 0 }}
        animate={
          loaded
            ? {
                scale: [1.9, 3.3, 2.0, 4, 2.2, 2.7, 3],
                y: [-40, 200, -20, -200, 50, -80, 0],
                x: [-100, 40, -100, 85, 0],
                opacity: [1, 1, 1, 1, 0],
              }
            : {}
        }
        exit={{ opacity: 0 }}
        transition={{ duration: 10, ease: "easeInOut" }}
      />
    </Container>
  );
};
